export const ALLOWED_EXTERNAL_DOMAINS = [
  "www.elogo.com.tr",
  "elogo.com.tr"
];